import { zodResolver } from '@hookform/resolvers/zod';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { TextFieldInput } from '../../core/inputs/TextFieldInput';
import {
  ILegalClientAccounting,
  legalClientAccountingSchema,
} from '../../Interfaces/ILegalClientAccounting';

interface IProps {
  defaultValues: ILegalClientAccounting;
  unmount: (newValue?: ILegalClientAccounting) => void;
}

export const BankInformationDialog = ({ defaultValues, unmount }: IProps) => {
  const isEdit = useMemo(
    () => defaultValues.idAccounting > 0,
    [defaultValues.idAccounting]
  );

  const formMethods = useForm<ILegalClientAccounting>({
    defaultValues,
    resolver: zodResolver(legalClientAccountingSchema),
    mode: 'onChange',
  });

  const {
    handleSubmit,
    formState: { isSubmitting, isValid, isDirty },
  } = formMethods;

  return (
    <Dialog open={true} onClose={() => unmount()} fullWidth maxWidth='xs'>
      <DialogTitle>
        Bankinformation {isEdit ? 'bearbeiten' : 'hinzufügen'}
      </DialogTitle>
      <FormProvider {...formMethods}>
        <Box
          component='form'
          noValidate
          onSubmit={handleSubmit((data: ILegalClientAccounting) =>
            unmount(data)
          )}
        >
          <DialogContent>
            <TextFieldInput
              name='Bank'
              label='Bank'
              required
              size='small'
              margin='dense'
              fullWidth
            />
            <TextFieldInput
              name='IBAN'
              label='IBAN'
              required
              size='small'
              margin='dense'
              fullWidth
            />
            <TextFieldInput
              name='BIC'
              label='BIC'
              required
              size='small'
              margin='dense'
              fullWidth
            />
          </DialogContent>
          <DialogActions
            sx={{ px: 3, py: 2, borderTop: 1, borderColor: 'divider' }}
          >
            <Button variant='outlined' onClick={() => unmount()}>
              Abbrechen
            </Button>
            <Button
              type='submit'
              variant='contained'
              disabled={isSubmitting || !isDirty || !isValid}
            >
              Speichern
            </Button>
          </DialogActions>
        </Box>
      </FormProvider>
    </Dialog>
  );
};
